import { Card, Typography, CardMedia, CardContent } from "@mui/material";
import moment from 'moment'

import useStyles from './styles'

const Product = ({ product }) => {
    const classes = useStyles()
    return ( 
        <Card elevation={3} className={classes.card}>
         <Typography gutterBottom align='center' variant='subtitle1'>{product.title}</Typography>

         <CardMedia className={classes.cardMedia} height='80' component="img" image={product.selectedFile} alt={product.selectedFile}  />

         <CardContent>
        <div className={classes.overlay}>
            <Typography fontSize='.9rem' gutterBottom align='center' variant='body2'>
                stored {moment(product.addedDate).fromNow()}
            </Typography>
            <Typography fontSize='.8rem' align='center' variant='body2'>
                by {product.name}
            </Typography>
        </div>
         
         <Typography align='center' variant='subtitle1'>
            Total: <span>{product.quantity}</span>
        </Typography>

         </CardContent>
        </Card>
     );
}
 
export default Product;